// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"TasksFilterChip-module__tooltip--ar8ku","tooltipContent":"TasksFilterChip-module__tooltipContent--1D8b8","option":"TasksFilterChip-module__option--2o30A"};